export default function FilterBar({ types, options, filterType, setFilterType, filterValue, setFilterValue }) {
  return (
    <div style={{ marginBottom: '1.25rem' }}>
      {/* Filter type row */}
      <div style={{ display: 'flex', gap: '0.35rem', marginBottom: '0.65rem', flexWrap: 'wrap' }}>
        {types.map(ft => {
          const active = filterType === ft;
          return (
            <button
              key={ft}
              onClick={() => { setFilterType(ft); setFilterValue('All'); }}
              style={{
                padding: '0.4rem 0.8rem', minHeight: 32,
                background: active ? 'rgba(140,207,225,0.14)' : 'transparent',
                border: `1px solid ${active ? 'rgba(140,207,225,0.45)' : 'var(--border)'}`,
                borderRadius: 3,
                fontFamily: "'Josefin Sans', sans-serif",
                fontSize: '0.6rem', letterSpacing: '0.12em', textTransform: 'uppercase',
                color: active ? 'var(--em)' : 'var(--text2)',
                cursor: 'pointer', transition: 'all 0.15s',
              }}
            >
              {ft}
            </button>
          );
        })}
      </div>
      {/* Filter value pills */}
      <div style={{
        display: 'flex', gap: '0.35rem', overflowX: 'auto',
        paddingBottom: '0.25rem', scrollbarWidth: 'none',
      }}>
        {(options[filterType] ?? ['All']).map(opt => (
          <button
            key={opt}
            className={`pill-btn${filterValue === opt ? ' active' : ''}`}
            onClick={() => setFilterValue(opt)}
            style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}
